import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetTheaterHome502 } from "../../../../hooks/theater/theater.hooks";
import clapperIcon from "./images/movie.png";
import styles from "./style.module.scss";

const PopularShorts = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading } = useGetTheaterHome502();

  const list = useMemo(() => {
    const bestsellers = data?.bestsellers;
    if (!Array.isArray(bestsellers)) return [];
    return bestsellers;
  }, [data]);

  if (isLoading || !list.length) return null;

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleWrap}>
          <span className={styles.titleIcon}>
            <img src={clapperIcon} alt="clapper" className={styles.clapperIcon} />
          </span>
          <h3 className={styles.title}>{t("home.popularShorts.title")}</h3>
        </div>
        <button type="button" className={styles.more} onClick={() => navigate("/theater")}>
          {t("home.popularShorts.more")}
        </button>
      </div>

      <div className={styles.list}>
        {list.map((item) => (
          <button
            type="button"
            key={item.id}
            className={styles.card}
            onClick={() => navigate("/theater")}
          >
            <div className={styles.coverWrap}>
              <img className={styles.cover} src={item.cover_image} alt={item.title || ""} />
              {item.is_vip_exclusive ? <span className={styles.vip}>VIP</span> : null}
              <span className={styles.source}>
                <span className={styles.sourceDot} />
                DramaBox
              </span>
            </div>
            <div className={styles.cardTitle}>{item.title}</div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default PopularShorts;
